module.exports = __webpack_public_path__ + "img/preloader.ca49bba4.svg";